import { makeCancellable, takeLatest } from "vuex-cancellable-actions";
import Logger from "./../lib/logger";
import Util from "./../lib/util";
import { RepositoryFactory } from "./../repository/RepositoryFactory";

const InfoJsonRepository = RepositoryFactory.get("infoJson");
const timeFormat = "YYYY/MM/DD HH:mm";

export default {
  namespaced: true,
  state: {
    informationConfig: null,
    /** お知らせ結果一覧 */
    rsltListInfo: [],
    /** お知らせ情報 */
    informationInfo: {},
    /** 緊急お知らせ一覧 */
    emergency: [],
    /** 任意お知らせ */
    any: [],
    /** お知らせ件数 */
    infoCnt: 0,
    /** お知らせパラメータ */
    infoParam: null,
    /** 検索状態 [1:検索前 2:検索中 3:検索後] */
    searchStatus: 1,
    /** 緊急お知らせ選択中レコード */
    emergencyInfoIndex: 0,
    /** 任意お知らせ選択中レコード */
    anyInfoIndex: 0,
    /** お知らせのタイトルと色 */
    titleSummaryCode: {},
  },
  mutations: {
    setInformationConfig(state, config) {
      Logger.debug("[info]mut - setInformationConfig(" + config + ")");
      state.informationConfig = config;
    },

    /** 緊急お知らせ一覧設定 */
    setEmergencyInfo(state, info) {
      Logger.info("[info]mut - setEmergencyInfo()");
      Logger.dir(info);
      state.emergency = info;
    },
    /** 任意お知らせ設定 */
    setAnyInfo(state, info) {
      Logger.info("[info]mut - setAnyInfo()");
      Logger.dir(info);
      state.any = info;
    },
    /**
     * お知らせ結果一覧をstateに設定
     * @param {*} state
     * @param {*} data
     */
    setRsltListInfo(state, data) {
      Logger.debug("[info]mut - setRsltListInfo(data)");
      Logger.dir(data);
      state.rsltListInfo = data;
    },
    /**
     * お知らせ情報をstateに設定
     * @param {*} state
     * @param {*} data
     */
    setInformationInfo(state, data) {
      Logger.debug("[info]mut - setInformationInfo(data)");
      Logger.dir(data);
      state.informationInfo = data;
    },
    /**
     * お知らせ件数をstateに設定
     * @param {*} state
     * @param {*} data
     */
    setInfoCnt(state, data) {
      Logger.debug("[info]mut - setInfoCnt(data)");
      Logger.dir(data);
      state.infoCnt = data;
    },
    /**
     * お知らせパラメータをstateに設定
     * @param {*} state
     * @param {*} data
     */
    setInfoParam(state, data) {
      state.infoParam = data;
    },
    /**
     * 検索状態パラメータをstateに設定
     * @param {*} state
     * @param {*} data
     */
    setSearchStatus(state, data) {
      Logger.debug("[info]mut - setSearchStatus(" + data + ")");
      state.searchStatus = data;
    },
    /** 緊急お知らせ選択中レコードを設定 */
    setEmergencyInfoIndex(state, index) {
      Logger.debug("[map]mut - setEmergencyInfoIndex(" + index + ")");
      state.emergencyInfoIndex = index;
    },
    /** 任意お知らせ選択中レコードを設定 */
    setAnyInfoIndex(state, index) {
      Logger.debug("[map]mut - setAnyInfoIndex(" + index + ")");
      state.anyInfoIndex = index;
    },
    /** お知らせのタイトルと色の設定 */
    setInfoTitleColor(state, data) {
      Logger.debug("[map]mut - setInfoTitleColor(" + data + ")");
      state.titleSummaryCode = data;
    },
  },
  actions: makeCancellable({
    /** 緊急お知らせ一覧取得 */
    async getEmergencyInfo({ commit }) {
      Logger.info("[info]act - getEmergencyInfo()");
      // APIからデータ取得
      Logger.info("[info]API - getEmergencyInfo()");
      const { data, error } = await InfoJsonRepository.getEmergencyInfo();
      Logger.info("[info]API - getEmergencyInfo() - return");
      Logger.dir(data);
      Logger.dir(error);
      if (!error) {
        commit("setEmergencyInfo", data.info);
      }
    },
    /** 任意お知らせ取得 */
    async getAnyInfo({ commit }) {
      Logger.info("[info]act - getAnyInfo()");
      // APIからデータ取得
      Logger.info("[info]API - getAnyInfo()");
      const { data, error } = await InfoJsonRepository.getAnyInfo();
      Logger.info("[info]API - getAnyInfo() - return");
      Logger.dir(data);
      Logger.dir(error);
      if (!error) {
        commit("setAnyInfo", data.info);
      }
    },

    /**
     * お知らせ情報取得
     */

    getRsltListInfo: takeLatest(async function(
      { commit },
      { appTime, infoKndCd, areaCd, target, summaryCd }
    ) {
      Logger.debug(
        "[info]act - getRsltListInfo(" +
          "appTime:" +
          appTime +
          "infoKndCd:" +
          infoKndCd +
          ",areaCd:" +
          areaCd +
          ",target:" +
          target +
          ",summaryCd" +
          ")"
      );
      Logger.dir(summaryCd);

      // パラメータセット
      let param = {
        /** 表示時刻 */
        dispTime: Util.formatDate(appTime, "YYYY-MM-DD HH:mm"),
        /** お知らせ種別 */
        infoKind: infoKndCd,
        /** 地方 */
        area: areaCd,
        /** お知らせ対象 */
        target: target,
        /** お知らせ分類 */
        division: summaryCd,
      };

      Logger.debug(
        "[info]API - getRsltListInfo(" +
          "appTime:" +
          appTime +
          "infoKndCd:" +
          infoKndCd +
          ",areaCd:" +
          areaCd +
          ",target:" +
          target +
          ",summaryCd" +
          ")"
      );
      Logger.dir(summaryCd);
      // 検索状態を「検索中」にする
      commit("setSearchStatus", 2);
      // ファイルからデータ取得
      const { data } = await InfoJsonRepository.getInformationInfo();
      Logger.info("[info]API - getInformationInfo() - return");
      Logger.dir(data);
      let infoList = [];
      let result = {
        infoList: infoList,
      };
      // 表示するお知らせ情報の抽出
      data.info.forEach((val) => {
        if (
          (val.infoKindCode === param.infoKind || null === param.infoKind) &&
          (val.areaCode === param.area || null === param.area) &&
          (val.target === param.target || null === param.target)
        ) {
          if (param.division.length > 0) {
            let cnt = 0;
            param.division.forEach((sumCd) => {
              if (val.summaryCode === sumCd) {
                cnt = cnt + 1;
                return;
              }
            });
            if (cnt === 0) {
              return;
            }
          }
          infoList.push({
            infoManageCode: val.infoManageCode,
            machineId: val.machineId,
            indexNum: val.indexNum,
            announceTime: val.announceTime,
            infoKindCode: val.infoKindCode,
            areaCode: val.areaCode,
            areaName: val.areaName,
            summary: val.summary,
            detail: val.detail,
            startTime: val.startTime,
            endTime: val.endTime,
            specFlag: val.specFlag,
            target: val.target,
            summaryCode: val.summaryCode,
            relObs: val.relObs,
          });
        }
      });
      Logger.dir(result);
      commit("setRsltListInfo", result.infoList);
      commit("setInfoCnt", result.infoList.length);
      commit("setInfoParam", param);
      // 検索状態を「検索後」にする
      commit("setSearchStatus", 3);
    }),
    /**
     * お知らせ情報取得
     *@param infoManageCd お知らせ管理番号
     */

    getInformationInfo: takeLatest(async function(
      { commit, state },
      infoManageCd
    ) {
      Logger.debug("[info]act - getInformationInfo(" + infoManageCd + ")");
      //お知らせ一覧情報の取得
      const { data } = await InfoJsonRepository.getInformationInfo();
      commit("setRsltListInfo", data.info);
      const infoList = state.rsltListInfo;
      let detailInfo = {};
      infoList.forEach((val) => {
        if (val.infoManageCode === infoManageCd) {
          detailInfo = val;
          return;
        }
      });
      Logger.dir(detailInfo);
      commit("setInformationInfo", detailInfo);
    }),

    /**
     * 緊急度が一番高いお知らせ情報を元にボタン変更
     * @param information お知らせ一覧情報
     */
    getInfoTitleColor: takeLatest(async function (
      { commit, state },
      information
    ) {
      Logger.debug("[map]act - getInfoTitleColor(" + information + ")");
      if (information.length == 0 || state.informationConfig.titleSummaryCode === undefined) return;
      // お知らせのsummaryCodeでグループ化
      let summaryCodeList = information.information.reduce((acc, obj) => {
        if (!acc.includes(obj.summaryCode)) {
          acc.push(obj.summaryCode);
        }
        return acc;
      }, []);
      // settings.jsonを並び替え
      let sortInfoTitleColor = Object.entries(state.informationConfig.titleSummaryCode).sort(function(a, b) {
        // priorityの昇順で並び替え
        if (a[1].priority > b[1].priority) return 1;
        if (a[1].priority < b[1].priority) return -1;
        // summaryCodeの昇順で並び替え
        if (a[0] > b[0]) return 1;
        if (a[0] < b[0]) return -1;
        return 0;
      });
      // summaryCodeが5(その他)のお知らせボタンの文字と色を初期値に設定
      let infoConfig = state.informationConfig.titleSummaryCode["5"];
      // setting.jsonのsummaryCodeと一致するお知らせがあれば、対応する文字と色を設定
      for (let index=0; index < sortInfoTitleColor.length; index++) {
        const infoTitleColor = sortInfoTitleColor[index];
        const checkFlg = summaryCodeList.some(obj => obj == infoTitleColor[0]);
        if (checkFlg) {
          infoConfig = infoTitleColor[1];
          break;
        }
      }
      commit("setInfoTitleColor", infoConfig);
    }),
  }),
  getters: {
    /**
     * お知らせ一覧の変換
     * @param {*} state stateオブジェクト
     */
    getInfoList(state) {
      const rsList = state.rsltListInfo;
      let infoList = [];
      let result = {
        infoList: infoList,
      };
      for (const key in rsList) {
        const info = rsList[key];
        let item = {
          infoManageCode: info.infoManageCode,
          infoKindName: state.informationConfig.infoKindCode[info.infoKindCode],
          areaName: info.areaName,
          target: state.informationConfig.target[info.target],
          summaryCode: state.informationConfig.summaryCode[info.summaryCode],
          announceTime: Util.formatDate(info.announceTime, timeFormat),
          summary: info.summary,
        };
        infoList.push(item);
      }
      return result;
    },
    /**
     * お知らせ詳細の変換
     * @param {*} state stateオブジェクト
     */
    getInfo(state) {
      const rsInfo = state.informationInfo;
      let info = {
        infoManageCode: rsInfo.infoManageCode,
        machineId: rsInfo.machineId,
        indexNum: rsInfo.indexNum,
        announceTime: Util.formatDate(rsInfo.announceTime, timeFormat),
        infoKindName: state.informationConfig.infoKindCode[rsInfo.infoKindCode],
        areaName: rsInfo.areaName,
        summary: rsInfo.summary,
        detail: rsInfo.detail,
        startTime: rsInfo.startTime,
        endTime: rsInfo.endTime,
        specFlag: rsInfo.specFlag,
        target: state.informationConfig.target[rsInfo.target],
        summaryCode: state.informationConfig.summaryCode[rsInfo.summaryCode],
        relObs: rsInfo.relObs,
      };
      return info;
    },
  },
};
